import { AuthRepository } from '../../domain/repositories/auth.repository';
import { ApiRestDataSource } from '../datasources/api.rest.datasource';
import {
  IUserLogin,
  IValidateAccount,
  ILogin2faRequest,
  IMagicLinkRequest,
  ISocialRegisterRequest,
} from '../../domain/interfaces/auth.interface';
import { ILoginResponse } from '../../domain/interfaces/auth.interface';
import { IUserRegister } from '../../domain/interfaces/auth.interface';
import { IForgotPassword } from '../../domain/interfaces/auth.interface';
import { IChangePassword } from '../../domain/interfaces/auth.interface';
import { IResponseMessage } from '@/core';
import { ISocialLoginRequest } from '../../domain/interfaces/social-auth.interface';

export class AuthRepositoryImpl implements AuthRepository {
  constructor(private dataSource: ApiRestDataSource) {
    this.dataSource = dataSource;
  }

  async login(user: IUserLogin): Promise<ILoginResponse> {
    return this.dataSource.login(user);
  }

  async loginWithToken(token: string): Promise<ILoginResponse> {
    return this.dataSource.loginWithToken(token);
  }

  async socialLogin(data: ISocialLoginRequest): Promise<ILoginResponse> {
    return this.dataSource.socialLogin(data);
  }

  async socialRegister(data: ISocialRegisterRequest): Promise<ILoginResponse> {
    return this.dataSource.socialRegister(data);
  }

  async loginWith2fa(data: ILogin2faRequest): Promise<ILoginResponse> {
    return this.dataSource.loginWith2fa(data);
  }

  async sendMagicLink(data: IMagicLinkRequest): Promise<IResponseMessage> {
    return this.dataSource.sendMagicLink(data);
  }

  async impersonateUser(email: string): Promise<ILoginResponse> {
    return this.dataSource.impersonateUser(email);
  }

  async register(user: IUserRegister): Promise<IResponseMessage> {
    return this.dataSource.register(user);
  }

  async forgotPassword(data: IForgotPassword): Promise<IResponseMessage> {
    return this.dataSource.forgotPassword(data);
  }

  async resetPassword(data: IChangePassword): Promise<IResponseMessage> {
    return this.dataSource.resetPassword(data);
  }

  async resendActivationCode(email: string): Promise<IResponseMessage> {
    return this.dataSource.resendActivationCode(email);
  }

  async validateAccount(data: IValidateAccount): Promise<IResponseMessage> {
    return this.dataSource.validateAccount(data);
  }
}
